export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-120x120-d58e495d86364a303fa3f3cc6164cc02.png";